import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NHATestDirective } from '@nha/directives/test/test.directive';

export type AlertBoxType = 'info' | 'warning' | 'error' | 'success';

@Component({
	selector: 'nha-alert-box',
	templateUrl: './nha-alert-box.component.html',
	styleUrls: ['./nha-alert-box.component.scss'],
	imports: [MatIconModule, NHATestDirective]
})
export class NHAAlertBoxComponent {
	// Plain text; leave it unset to project rich content (links, emphasis) between the tags instead.
	message = input<string>();
	type = input<AlertBoxType>('info');

	icon = computed(() => {
		switch (this.type()) {
			case 'warning':
				return 'warning';
			case 'error':
				return 'error';
			case 'success':
				return 'check_circle';
			case 'info':
			default:
				return 'info';
		}
	});
}
